import { useState, useEffect } from 'react'
import { fetchData } from '../../../../global/utils/fetch'
import { STATUS } from '../../../../global/types/audit'
import { getExampleImages as getExampleImagesAPI } from './api'

interface ExampleImage {
  url: string
  type: string
}

interface UseExampleImagesOptions {
  auditType: STATUS | null
  sectionKey: string | null
}

export function useExampleImages({
  auditType,
  sectionKey,
}: UseExampleImagesOptions) {
  const [exampleImages, setExampleImages] = useState<string[]>([])
  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  // Fetch example images when section changes
  useEffect(() => {
    if (!auditType || !sectionKey) {
      setExampleImages([])
      setCurrentImageIndex(0)
      return
    }

    const fetchImages = async () => {
      try {
        const images = await fetchData<ExampleImage[]>(
          getExampleImagesAPI(auditType, sectionKey)
        )

        if (images && images.length > 0) {
          const imageUrls = images.map((img) => img.url)
          setExampleImages(imageUrls)
          setCurrentImageIndex(0)
        } else {
          setExampleImages([])
          setCurrentImageIndex(0)
        }
      } catch (error) {
        console.error('Failed to fetch example images:', error)
        setExampleImages([])
        setCurrentImageIndex(0)
      }
    }

    fetchImages()
  }, [auditType, sectionKey])

  const handlePreviousImage = () => {
    setCurrentImageIndex((prev) =>
      prev > 0 ? prev - 1 : exampleImages.length - 1,
    )
  }

  const handleNextImage = () => {
    setCurrentImageIndex((prev) =>
      prev < exampleImages.length - 1 ? prev + 1 : 0,
    )
  }

  return {
    exampleImages,
    currentImageIndex,
    handlePreviousImage,
    handleNextImage,
  }
}
